import { FC, useEffect, useState } from "react";
import "./CancelReason.scss";
import MainNavbar from "../../../components/MainNavbar/MainNavbar";
import { BvIcon } from "bevi-icon";
import { SubscriptionsService } from "../../../services/Financial/Subscriptions/SubscriptionsServices";
import { ProfileService } from "../../../services/Profile/ProfileService";
import { useNavigate } from "react-router-dom";

interface Motive {
  id: number;
  name: string;
}

interface CancelReasonProps {}

const subscriptionsService = new SubscriptionsService();
const profileService = new ProfileService();

const CancelReason: FC<CancelReasonProps> = () => {
  const navigate = useNavigate();
  const [motives, setMotives] = useState<Motive[]>([]);
  const [selectedMotiveId, setSelectedMotiveId] = useState<number | null>(null);
  const [otherText, setOtherText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const selectedMotive = motives.find((m) => m.id === selectedMotiveId);
  const isOtherSelected = selectedMotive?.name?.toLowerCase() === "outros";

  useEffect(() => {
    const init = async () => {
      const [subscription] = await profileService.getActiveSubscription();
      if (!subscription?.data || subscription.data.canceled) {
        navigate("/profile/general", { replace: true });
        return;
      }

      const [response] = await subscriptionsService.listCancellationMotives();
      setIsLoading(false);
      if (response?.data) {
        setMotives(response.data);
      }
    };

    init();
  }, []);

  const handleSubmit = async () => {
    if (!selectedMotiveId) return;
    setIsSubmitting(true);
    const description = isOtherSelected ? otherText.trim() : undefined;
    const [response] = await subscriptionsService.cancel(selectedMotiveId, description);
    setIsSubmitting(false);
    if (response) navigate("/cancelation/confirmation", { state: { refund_amount: response?.data?.refund_amount ?? null } });
  };

  return (
    <>
      <MainNavbar />
      <div className="CancelReason" data-testid="CancelReason">
        <div className="cancel-card">
          <h2 className="cancel-title">Ajude-nos a melhorar!</h2>
          <p className="cancel-subtitle">
            Por que você deseja cancelar sua assinatura?
          </p>

          {isLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
            </div>
          ) : (
            <div className="cancel-reasons">
              {motives.map((motive) => (
                <label key={motive.id} className={`form-check cancel-reason-option${selectedMotiveId === motive.id ? " selected" : ""}`}>
                  <input
                    type="checkbox"
                    name="cancel-reason"
                    className="form-check-input mx-1 cancel-input"
                    value={motive.id}
                    checked={selectedMotiveId === motive.id}
                    onChange={() => setSelectedMotiveId(motive.id)}
                  />
                  <span className="cancel-reason-label">{motive.name}</span>
                </label>
              ))}
            </div>
          )}

          {isOtherSelected && (
            <div className="cancel-other-wrapper">
              <label className="cancel-other-label">Escreva aqui o motivo</label>
              <textarea
                className="cancel-other-textarea"
                maxLength={255}
                value={otherText}
                onChange={(e) => setOtherText(e.target.value)}
              />
            </div>
          )}

          <button
            className={`cancel-submit-btn${isSubmitting ? " loading" : ""}`}
            onClick={handleSubmit}
            disabled={!selectedMotiveId || (isOtherSelected && !otherText.trim()) || isSubmitting}
          >
            {isSubmitting ? (
              <span className="spinner-border spinner-border-sm" role="status" />
            ) : (
              <>
                Cancelar
                <BvIcon name="chevronForward" weight={600} width={12} height={12} color="FFFFFF"/>
              </>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default CancelReason;
